export { useCheckAgeVerification } from './use-check-age-verification';
